import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { INCLUSIONS, PRICING } from "@/lib/content";

export const Pricing = () => (
  <section className="bg-white py-16 sm:py-28 rule scroll-mt-16" id="pricing" data-testid="pricing-section">
    <div className="container-x grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <div className="lg:col-span-6">
        <p className="eyebrow mb-5">Pricing</p>
        <h2 className="h-editorial" data-testid="pricing-heading">One assessment.<br /> A clearer picture of home.</h2>
        <div className="mt-8 sm:mt-10 flex flex-wrap items-end gap-x-5 gap-y-2">
          <p className="font-serif text-[4.5rem] sm:text-7xl lg:text-8xl leading-none text-forest" data-testid="pricing-price">${PRICING.base.toLocaleString()}</p>
          <div className="pb-2">
            <p className="text-sm font-semibold text-ink">Home Hyper Assessment</p>
            <p className="text-sm text-sec">Reserve with a ${PRICING.deposit} deposit</p>
          </div>
        </div>
        <ul className="mt-6 space-y-2 text-[15px] sm:text-sm text-ink leading-relaxed">
          <li>Lab fees included.</li>
          <li data-testid="pricing-deposit-line">${PRICING.deposit} deposit today, applied to your total · remaining ${(PRICING.base - PRICING.deposit).toLocaleString()} due 24 hours before your confirmed visit.</li>
          <li className="text-sec">Optional laboratory add-ons are available during booking and charged in full at booking.</li>
        </ul>
      </div>
      <div className="lg:col-span-6 lg:pl-8">
        <div className="rounded-md border border-divider bg-mint p-6 sm:p-8" data-testid="pricing-card">
          <p className="mono uppercase tracking-[0.16em] text-sec">Everything included</p>
          <ul className="mt-5 space-y-3.5" data-testid="pricing-inclusions">
            {INCLUSIONS.map((t) => (
              <li key={t} className="flex items-start gap-3 text-[15px] text-ink">
                <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-forest text-white"><Check size={12} strokeWidth={3} /></span>{t}
              </li>
            ))}
          </ul>
          <div className="mt-7 border-t border-divider pt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div><p className="mono uppercase tracking-wider text-sec">Total</p><p className="font-mono text-2xl text-ink">${PRICING.base.toLocaleString()}</p></div>
            <Link to="/book" className="btn-primary" data-testid="pricing-book-cta">Reserve — ${PRICING.deposit} deposit <ArrowRight size={18} /></Link>
          </div>
          <p className="mt-4 text-xs text-sec leading-relaxed">${PRICING.deposit} deposit at booking. We confirm your appointment within 24 hours.</p>
        </div>
      </div>
    </div>
  </section>
);
